import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RotateLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/RotateLeftOutlined";
import AntdIcon from "../components/AntdIcon";
var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RotateLeftOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(RotateLeftOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'RotateLeftOutlined';
}
export default RefIcon;